import { SuccessView } from "../shared/components/success-view.js";

interface ContentSuccessProps {
  onResend: () => void;
  name: string;
  smsSent: boolean;
}

export function ContentSuccess({ onResend, name, smsSent }: ContentSuccessProps) {
  return <SuccessView name={name} onResend={onResend} smsSent={smsSent} />;
}
